export default function AppContextoService() {
  const setAppContext = (acesso) => {
    let itens = {};
    Object.keys(acesso.values).forEach(key => {
      if (key !== 'database' && key !== 'entity') {
        itens[key] = { value: acesso.values[key], insulation: true }
      }
    });

    this.appContext = _.isEmpty(itens) ? undefined : btoa(JSON.stringify(itens));
  };

  const clearAppContext = () => {
    this.appContext = undefined;
  };

  return {
    setAppContext,
    clearAppContext,
  };
}
